import React from 'react';
import { MyPortfolioCapsuleContentProps } from 'widgets/myPortfolioCapsules/MyPortfolioCapsuleWidgetStrategy';
import { useMyPortfolioCapsuleConfigSlice } from 'widgets/myPortfolioCapsules/store/config/configSlice';
import { useWidgetContext } from 'widgets/WidgetContext';
import { VenueTypeCapsuleContent } from 'widgets/venueAnalysis/capsules/venueTypeCapsule/components/content/VenueTypeCapsuleContent';

import { venueAnalysisStreamedDataSelectors } from 'widgets/venueAnalysis/store/stream/streamSlice';
import { getVenueAnalysisData } from 'widgets/venueAnalysis/venueAnalysisAggregatedData';
import { VenueAnalysisCapsuleConfigState } from 'widgets/venueAnalysis/capsules/store/VenueAnalysisCapsuleConfigState';
export function VenueTypeCapsuleMyPortfolioCapsuleContent(
    props: MyPortfolioCapsuleContentProps
) {
    const { symbol } = props;
    const { config, dispatchConfigChanged } =
        useMyPortfolioCapsuleConfigSlice<VenueAnalysisCapsuleConfigState>();

    const { widgetKey } = useWidgetContext();
    const { useSymbolStreamedData } = venueAnalysisStreamedDataSelectors;

    const streamData = useSymbolStreamedData(symbol, config);
    const data = getVenueAnalysisData(
        streamData,
        undefined,
        config.includePreviousDaysFills
    );

    return (
        <VenueTypeCapsuleContent
            data={data}
            config={config}
            dispatchConfigChanged={dispatchConfigChanged}
            symbol={symbol}
            capsuleKey={`${widgetKey}=${symbol}`}
            showOrderData={false}
        />
    );
}
